import React from 'react';
import ReactDOM from 'react-dom';
import * as ld from 'lodash';
import classNames from 'classnames';
import dropdownStyle from '../dropdown/dropdown.less';
import textInputStyle from '../text.input/text.input.less';
import FormPureComponent from './../generic.component.jsx';
import checkboxStyle from './checkbox.less';
import { setFieldValue, resetFieldValue } from '../../app.reducer.jsx';
import autocompleteCheckboxStyle from './autocomplete.checkbox.less';
import { bindActionCreators } from '../../app.store.jsx';
import { setAutocompleteText } from '../autocomplete/reducer.jsx';
import { getPropsOrDefault, KEY_CODES, compareObjectsInclusive } from '../../../common/utils.jsx';
import DontKnowBtn from '../dont.know.btn/dont.know.btn.jsx';
import { AjaxAutocomplete } from '../autocomplete/autocomplete.jsx';
import { AUTOCOMPLETE_STATUS_PENDING, AUTOCOMPLETE_STATUS_IDLE } from '../autocomplete/reducer.jsx';
import { EMPTY_OBJECT, EMPTY_STRING } from '../../questionnaire.utils.jsx';
import { Checkbox } from './checkbox.jsx';

const UNKNOWN = 'UNKNOWN';
export class AutocompleteCheckbox extends AjaxAutocomplete {
    constructor(props) {
        super(props);
        this.state = { active: false, menuPointer: null, showFullList: false, currentInputIndex: 1 };
        this.optionClickHandler = this.optionClickHandler.bind(this);
        this.onInputUpdate = this.onInputUpdate.bind(this);
        this.onKeyPressHandler = this.onKeyPressHandler.bind(this);
        this.isInputChecked = this.isInputChecked.bind(this);
        this.showDropDownList = this.showDropDownList.bind(this);
        this.getOptionsFromFullList = this.getOptionsFromFullList.bind(this);
        this.getStatus = this.getStatus.bind(this);
        this.onCheckHandler = this.onCheckHandler.bind(this);
        this._staticProps = {
            id: `autocomplete-${this.props.inputIndex}`
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        const { storageName, components } = this.props;
        //Don't use getPropsOrDefault here to improve performance
        const currentStorage = components && components.autocomplete && components.autocomplete[storageName];
        const updatedStorage = nextProps.components && nextProps.components.autocomplete && nextProps.components.autocomplete[storageName];
        const storageIsUpdated = currentStorage !== updatedStorage;
        const propsForCheck = [ 'inputIndex', 'onOptionClickCallback', 'currentElement', 'showAll', 'value', 'unique', 'disabled' ];
        return storageIsUpdated
            || compareObjectsInclusive(this.props, nextProps, propsForCheck)
            || !ld.isEqual(this.props.variants, nextProps.variants)
            || !ld.isEqual(this.state, nextState);
        /*
        * props:
        * components, storageName, prefetch, inputIndex, onOptionClickCallback, currentElement
        * variants, service, prefetch, storageName, components, showAll, value, unique
        *
        *
        * state:
        * active, menuPointer, showFullList, currentInputIndex
        *
        * */
    }

    getStatus() {
        const { components, name } = this.props;
        return components && components.autocomplete && components.autocomplete[name] && components.autocomplete[name].status || AUTOCOMPLETE_STATUS_IDLE;
    }
    onKeyPressHandler(event) {
        const inputIndex = this.props.inputIndex;
        const isActive = this.state.active;
        const inputValue = event.target.value;
        if (!isActive) { return true; }
        const options = this.getOptionsFromFullList(inputValue);
        const optionsCount = options.length;
        let menuPointer = this.state.menuPointer;
        const keyCode = event.keyCode;
        const input = ReactDOM.findDOMNode(this);
        const dropDownItemHeight = 26;
        const dropDownMenuHeight = 200;
        const dropDownMenuCenter = Math.floor(dropDownMenuHeight / dropDownItemHeight / 2);
        if (keyCode === KEY_CODES.ARROW_DOWN) {
            menuPointer = AjaxAutocomplete.counter(menuPointer, 0, optionsCount, AjaxAutocomplete.INC);
            input.childNodes[1].scrollTop = dropDownItemHeight * (menuPointer - dropDownMenuCenter);
        } else if (keyCode === KEY_CODES.ARROW_UP) {
            menuPointer = AjaxAutocomplete.counter(menuPointer, 0, optionsCount, AjaxAutocomplete.DEC);
            input.childNodes[1].scrollTop = dropDownItemHeight * (menuPointer - dropDownMenuCenter);
        } else if (keyCode === KEY_CODES.ENTER) {
            let selectedOption = options[menuPointer];
            if (undefined === selectedOption) {
                selectedOption = options.find(({ name }) => name === inputValue) || { name: inputValue };
            }
            const value = selectedOption.value || selectedOption.name;
            if (selectedOption.value) {
                selectedOption.checked = true;
                selectedOption.id = selectedOption.value;
                this.props.onOptionClickCallback(selectedOption);
            } else {
                this.props.onChangeCallback(value, inputIndex);
            }
            this.setAutocompleteText(selectedOption.name);
            this.setState({ menuPointer: null, active: false });
            return true;
        } else if (keyCode === KEY_CODES.TAB) {
            this.setState({ menuPointer: null, active: false });
            return true;
        } else {
            return true;
        }
        this.setState({ menuPointer, showFullList: false });
        event.preventDefault();
    }
    optionClickHandler(valueId, name) {
        this.setAutocompleteText(name);
        this.setState({ showFullList: false });
        this.props.onOptionClickCallback({ id: valueId, name, checked: true });
    }
    onInputUpdate(event) {
        const { components, storageName, prefetch, inputIndex } = this.props;
        const value = event.target.value;
        const autocompleteStorage = components && components.autocomplete && components.autocomplete.__storage__;
        const storage = autocompleteStorage && autocompleteStorage[storageName] || EMPTY_OBJECT;
        let options, fieldValue;
        const lowercaseName = value.toLowerCase();
        this.setState({ active: true, showFullList: false });
        if (prefetch) {
            options = ld.filter(storage.fullList, ({ name }) => ld.startsWith(name.toLowerCase(), lowercaseName));
            fieldValue = value;
        } else {
            options = storage && storage.cache && storage.cache[value] || false;
            fieldValue = storage && storage.nameMap && storage.nameMap[value] || value;
        }
        if (false === options && storageName) { this.fetchData(value); }
        this.setAutocompleteText(value);
        this.props.onChangeCallback(fieldValue, inputIndex);
    }
    isInputChecked() {
        const currentElement = this.props.currentElement;
        return currentElement ? currentElement.checked : false;
    }
    onCheckHandler(event) {
        this.props.onCheckCallback(this.props.inputIndex, event);
    }
    showDropDownList(event) {
        const { inputIndex } = this.props;
        const currentInput = this.refs[`autocomplete-${inputIndex}`];
        currentInput.focus();
        event.preventDefault();
        this.setAutocompleteText(EMPTY_STRING);
        this.setState({ active: true, showFullList: true, currentInputIndex: inputIndex });
        this.showAllOptions();
    }
    showAllOptions() {
        const { components, storageName, service, prefetch, arrayOfItems: inputValues, variants, unique, value: propsValue } = this.props;
        let options = variants.concat();
        const storage = getPropsOrDefault(components, `autocomplete.__storage__.${storageName}`, EMPTY_OBJECT);
        const localValue = inputValues || propsValue;
        if (service && storageName && prefetch) {
            options = ld.filter(storage.fullList, ({ name }) => ld.startsWith(name.toLowerCase(), EMPTY_STRING));
        }
        return unique ? ld.remove(options, ({ value }) => -1 === ld.findIndex(localValue, ({ id }) => id === value)) : options;
    }
    getOptionsFromFullList(inputText) {
        const { storageName, components, variants, arrayOfItems: inputValues, unique, value: propsValue } = this.props;
        const lowercaseName = 'string' === typeof inputText ? inputText.toLowerCase() : EMPTY_STRING;
        const storage = getPropsOrDefault(components, `autocomplete.__storage__.${storageName}`, EMPTY_OBJECT);
        const filteredOptions = ld.filter(variants || storage.fullList, ({ name: itemName }) => ld.startsWith(itemName.toLowerCase(), lowercaseName));
        const localValue = inputValues || propsValue;
        return unique ? ld.remove(filteredOptions, ({ value }) => -1 === ld.findIndex(localValue, ({ id }) => id === value)) : filteredOptions;
    }
    render() {
        const { showAll, placeholder, inputIndex, currentInputIndex, currentElement, onFocusCallback,
            disabled, cssClass, wrapperClass } = this.props;
        const { showFullList, active } = this.state;
        const elementId = this._staticProps.id;

        const currentInput = isNaN(parseInt(currentInputIndex)) ? this.state.currentInputIndex : currentInputIndex;
        const inputText = currentElement ? currentElement.name : EMPTY_STRING;
        const checkValue = this.onCheckHandler;
        const options = showFullList ? this.showAllOptions() : this.getOptionsFromFullList(inputText);
        const status = this.getStatus();

        const isDropdownOpen = active && (0 !== options.length || AUTOCOMPLETE_STATUS_PENDING === status) && inputIndex === parseInt(currentInput);
        const inputClass = classNames(cssClass, AutocompleteCheckbox.STYLE.INPUT_CLASS, { [textInputStyle.active]: this.isInputChecked() }, { [textInputStyle.disabled]: disabled });
        const dropdownClass = classNames(dropdownStyle.autocompleteDropdownMenu, dropdownStyle.drowdownMenu, { [dropdownStyle.open]: isDropdownOpen });
        const iconClass = classNames(checkboxStyle.checkboxIcon, { [checkboxStyle.checked]: this.isInputChecked(inputIndex) });
        const buttonWrapper = classNames(wrapperClass, autocompleteCheckboxStyle.buttonWrapper);
        const tabIndex = disabled ? -1 : 0;
        return (
            <div tabIndex={tabIndex} id={elementId} className={buttonWrapper}>
                <input disabled={disabled} ref={elementId} type="text" className={inputClass} onFocus={onFocusCallback}
                    value={inputText} placeholder={placeholder} onChange={this.onInputUpdate}
                    onKeyDown={this.onKeyPressHandler}
                />
                {
                    isDropdownOpen
                    ?   <div className={dropdownClass}>
                            <ul className={dropdownStyle.dropdownList}>
                                { this.buildOptionsList(options) }
                            </ul>
                        </div>
                    : null
                }
                {
                    showAll
                        ?   <div className={autocompleteCheckboxStyle.dropdownCaretWrapper} onFocus={onFocusCallback} onClick={this.showDropDownList}>
                                <span className={autocompleteCheckboxStyle.dropdownCaret}></span>
                            </div>
                        : null
                }
                <span className={iconClass} onClick={checkValue}></span>
            </div>
        );
    }
}
AutocompleteCheckbox.STYLE = {
    INPUT_CLASS: classNames(textInputStyle.textInput, autocompleteCheckboxStyle.textInput, AjaxAutocomplete.INPUT_CLASS)
};

class CheckboxWrapper extends Checkbox {
    constructor() {
        super();
        this.onCheckHandler = this.onCheckHandler.bind(this);
    }
    onCheckHandler(event) {
        this.props.onChangeCallback(this.props.inputIndex, event);
    }
    render() {
        const { inputIndex, name, checked } = this.props;
        return (
            <Checkbox {...this.props} value={inputIndex} num={inputIndex} id={name} checked={checked}
                name={name} title={name} onChangeCallback={this.onCheckHandler}
                />
        );
    }
}

export default class AutocompleteCheckboxButtons extends FormPureComponent {
    constructor() {
        super();
        this._setAutocompleteText = bindActionCreators(setAutocompleteText);
        this._setFieldValue = bindActionCreators(setFieldValue);
        this._resetFieldValue = bindActionCreators(resetFieldValue);
        this.buildInputList = this.buildInputList.bind(this);
        this.onChangeHandler = this.onChangeHandler.bind(this);
        this.onFocusHandler = this.onFocusHandler.bind(this);
        this.optionClickHandler = this.optionClickHandler.bind(this);
        this.onCheckHandler = this.onCheckHandler.bind(this);
        this.restoreValuesFromState = this.restoreValuesFromState.bind(this);
        this.initDefaultVariants = this.initDefaultVariants.bind(this);
        this.state = {
            arrayOfItems: [],
            currentInputIndex: null
        };
    }

    static saveCheckedFields(fieldsArray) {
        return fieldsArray.reduce((checkedFields, { age, id, checked }) => {
            if (checked) {
                checkedFields.push(age ? `${id}, ${age}` : id);
            }
            return checkedFields;
        }, [/* _NEW_ empty array */]);
    }
    initDefaultVariants(storage) {
        const { defaultVariants, root, variants } = this.props;
        const arrayOfItems = this.state.arrayOfItems;
        const initState = [];
        if (defaultVariants && (variants || storage.fullList) && defaultVariants.length > arrayOfItems.length) {
            const defaultOptions = ld.filter(variants || storage.fullList, ({ value }) => -1 !== ld.indexOf(defaultVariants, value));
            if (0 < defaultOptions.length) {
                ld.forEach(defaultOptions, (item) => {
                    initState.push({ id: item.value, name: item.name, checked: false, readonly: true, root });
                });
                this.setState({ arrayOfItems: initState, currentInputIndex: defaultOptions.length + 1 });
            }
        }
    }
    restoreValuesFromState(storage) {
        const arrayOfItems = this.state.arrayOfItems;
        const { variants, value: propsValue, root } = this.props;
        if (propsValue && (variants || storage.fullList) && 0 < propsValue.length && propsValue.length > arrayOfItems.length) {
            const options = ld.filter(variants || storage.fullList, ({ value }) => -1 !== ld.indexOf(propsValue, value));
            const initState = ld.map(propsValue, (item, index) => {
                return {
                    id: options[index] ? options[index].value : propsValue[index],
                    name: options[index] ? options[index].name : propsValue[index],
                    checked: true,
                    root
                };
            });
            this.setState({ arrayOfItems: initState, currentInputIndex: propsValue.length + 1 });
        }
    }
    UNSAFE_componentWillMount() {
        const { defaultVariants, variants, value: propsValue, storageName } = this.props;
        const storage = getPropsOrDefault(this.props, `components.autocomplete.__storage__.${storageName}`, EMPTY_OBJECT);
        if (propsValue && 0 < propsValue.length && 'string' !== typeof propsValue) {
            const defaultOptions = ld.filter(variants || storage.fullList, ({ value }) => -1 !== ld.indexOf(defaultVariants, value));
            if (defaultVariants && defaultVariants.length > this.state.arrayOfItems.length) {
                const initState = ld.map(defaultOptions, (item) => {
                    return { id: item.value, name: item.name, checked: false, readonly: true, age: null };
                });
                for (let variantIndex = 0; variantIndex < propsValue.length; variantIndex++) {
                    const currentValue = propsValue[variantIndex].toString();
                    const newValue = currentValue.split(',');
                    const variantId = isNaN(parseInt(newValue[0])) ? newValue[0] : parseInt(newValue[0]);
                    const valueIndex = ld.findIndex(initState, ({ id }) => id === variantId);
                    const isStringNumber = 'string' === typeof propsValue[variantIndex] && !isNaN(parseInt(propsValue[variantIndex]));
                    if (-1 !== valueIndex && initState[valueIndex].id === variantId && !isStringNumber) {
                        initState[valueIndex].checked = true;
                        initState[valueIndex].age = parseInt(newValue[1]) || null;
                    } else {
                        const variant = ld.find(variants || storage.fullList, ({ value }) => value === variantId);
                        const variantName = variant && !isStringNumber ? variant.name : newValue[0];
                        const variantAge = parseInt(newValue[1]) || null;
                        initState.push({ id: newValue[0], name: variantName, checked: true, readonly: false, age: variantAge });
                    }
                }
                this.setState({ arrayOfItems: initState, currentInputIndex: initState.length + 1 });
            } else {
                this.restoreValuesFromState(storage);
            }
        } else {
            this.initDefaultVariants(storage);
        }
    }
    onCheckHandler(inputIndex, eventOrValue) {
        const value = eventOrValue.target ? eventOrValue.target.value : eventOrValue;
        if (EMPTY_STRING === value) { return; }
        const { name, root } = this.props;
        const arrayOfItems = this.state.arrayOfItems;
        const currentInput = arrayOfItems[inputIndex - 1];
        if (!currentInput || !currentInput.name) { return; }
        currentInput.checked = !currentInput.checked;
        const itemsId = AutocompleteCheckboxButtons.saveCheckedFields(arrayOfItems);
        this._setFieldValue(name, itemsId, root);
    }
    optionClickHandler(element) {
        const { arrayOfItems, currentInputIndex } = this.state;
        arrayOfItems[currentInputIndex - 1] = element;
        const itemsId = AutocompleteCheckboxButtons.saveCheckedFields(arrayOfItems);
        this._setFieldValue(this.props.name, itemsId, this.props.root);
    }
    onFocusHandler(event) {
        const inputIndex = parseInt(event.target.parentNode.id.split('-')[1]);
        const arrayOfItems = this.state.arrayOfItems;
        const currentInput = arrayOfItems[inputIndex - 1];
        if (currentInput) {
            this._setAutocompleteText(this.props.name, currentInput.name);
        }
        this.setState({ currentInputIndex: inputIndex });
    }
    onChangeHandler(value, inputIndex) {
        const { name, root, value: propsValue } = this.props;
        const { arrayOfItems } = this.state;
        let currentItem;
        if (UNKNOWN === value && !inputIndex) {
            if (propsValue === UNKNOWN) {
                this._resetFieldValue(name, root);
                return;
            }
            arrayOfItems.forEach((item) => item.checked = false);
            this._setFieldValue(name, value, root);
            return;
        }
        currentItem = { id: value, name: value };
        arrayOfItems[inputIndex - 1] = currentItem;
        const itemsId = AutocompleteCheckboxButtons.saveCheckedFields(arrayOfItems);
        this.setState({ arrayOfItems, currentInputIndex: parseInt(inputIndex) });
        if (arrayOfItems.length === parseInt(inputIndex)) { this.setState({ currentInputIndex: arrayOfItems.length }); }
        this._setFieldValue(name, itemsId, root);
    }
    buildInputList() {
        const { arrayOfItems, currentInputIndex } = this.state;
        const showAll = this.props.showAll;
        const inputs = [];
        for (let inputIndex = 1; inputIndex <= arrayOfItems.length + 1; inputIndex++) {
            const currentElement = arrayOfItems[inputIndex - 1];
            const readonly = currentElement ? currentElement.readonly : false;
            if (!readonly) {
                inputs.push(<AutocompleteCheckbox {...this.props} onChangeCallback={this.onChangeHandler}
                    key={inputIndex} inputIndex={inputIndex} onFocusCallback={this.onFocusHandler} arrayOfItems={arrayOfItems}
                    onOptionClickCallback={this.optionClickHandler} onCheckCallback={this.onCheckHandler}
                    currentElement={currentElement} currentInputIndex={currentInputIndex} showAll={showAll}
                />);
            } else {
                let name = currentElement.name;
                inputs.push(<CheckboxWrapper {...this.props} inputIndex={inputIndex} name={name}
                    checked={currentElement.checked} num={inputIndex} key={`checkbox-${inputIndex}`} onChangeCallback={this.onCheckHandler}
                />);
            }
        }
        return inputs;
    }
    render() {
        const { value, unknownAccepted, disabled } = this.props;
        const wrapperClass = classNames(checkboxStyle.fieldWrapper, dropdownStyle.autocompleteWrapper);
        return (
            <div className={wrapperClass}>
                { this.buildInputList() }
                {
                    unknownAccepted
                        ? <DontKnowBtn disabled={disabled} value={UNKNOWN} onChangeCallback={this.onChangeHandler} checked={ UNKNOWN === value }/>
                        : null
                }
            </div>
        );
    }
}
